<template>
    <div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
        <div id="TituloDetalleDeDocumento_div">
            <h6 class="label-black" >MOVIMIENTOS DE DOCUMENTOS</h6>
        </div>
        <div class="row d-flex">
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
                <div class="area custom-area" style="margin-top: 0px">
                        <div class="form-group" >
                                    <label class="label-black">Tipo de Movimiento</label>
                                    <select id="catalogoDeTipos" class="form-control" @change="cambiarTipo($event)">
                                        <option value= 0>SELECCIONE MOVIMIENTO</option>
                                        <option v-for="opcion in Tipos" :key="opcion.TipoId" :value="opcion.TipoId" >{{opcion.Nombre}}</option>
                                    </select>
                                </div>
                        <div class="form-group align-self-center" id="Codigo_div" v-if="parametros_Tipo.tipoId!=0">
                            <label class="label-black">Código:</label>
                            <input type="text" class="form-control" placeholder="##############" v-model="CodigoBarras" v-on:keyup.enter= 'DetectarEnter'/>
                        </div>
                        <div id="BotonBusqueda_div" class="form-group text-right" style="margin-top: 27px;" v-if="parametros_Tipo.tipoId!=0">
                            <button class="btn btn-sm btn-custom" @click='ConsultarDocumento()'>Buscar Documento</button>
                        </div>
                    
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 padding-div-low" style="margin-top:0px;margin-bottom:0px;" v-if="parametros_Tipo.tipoId==1">
                <div class="area custom-area" style="margin-top: 0px">
                    <div class="row">
                        <h6 class="label-black">Listado de Documentos para Envío, Total de Documentos : {{ListaEnvios.length}}</h6>
                    </div>
                    <div class="row table-responsive">
                            <table class="table table-striped table-light table-hover table-sm" id="tablaEnvios">
                                <thead class="thead-custom">
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Consecutivo</th>
                                        <th>Tipo de Elemento</th>
                                        <th>Usuario Actual</th>
                                        <th>Fecha de Recepción</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody class="text-dark" v-for="Lista in ListaEnvios" :key ="Lista.InventarioDocumentoId">
                                    <tr >
                                        <td width ="170" v-bind:rowspan="Lista.Movimientos.length + 1" v-if="Lista.ListadoArchivo==false"><h6 class="label-black"><span class="badge badge-primary">{{Lista.TipoDocumento.Nombre}}</span></h6></td>
                                        <td width ="170" v-bind:rowspan="Lista.Movimientos.length + 1" v-else><h6 class="label-black"><span class="badge badge-warning">{{Lista.TipoDocumento.Nombre}}</span></h6></td>
                                        <td class="text-center" width ="100" v-bind:rowspan="Lista.Movimientos.length + 1">{{Lista.Consecutivo}}/{{Lista.Anio}}{{(Lista.Sufijo!=null ? ('-'+ Lista.Sufijo) : '')}}</td>
                                    </tr>
                                    <tr v-for="Movimientos in Lista.Movimientos" :key ="Movimientos.MovimientoDocumentoId" >
                                      <td width ="200" v-html="desglosaContenido(Movimientos)"></td>
                                      <!-- <td width ="300" v-if="Movimientos.VolumenId!=null && Movimientos.TerceriaId== null && Movimientos.IncidenteId==null">Tomo No: {{Movimientos.Volumen.NumVolumen}}</td>
                                      <td width ="300" v-else-if="Movimientos.VolumenId==null && Movimientos.TerceriaId!= null && Movimientos.IncidenteId==null">Tercería No: {{Movimientos.Terceria.NumeroTerceria}}, Tipo {{Movimientos.Terceria.TipoTerceria}}</td>
                                      <td width ="300" v-else>Incidente No: {{Movimientos.Incidente.NumeroIncidente}}, Tipo: {{Movimientos.Incidente.TipoIncidente}}</td> -->
                                      <td width ="300" v-if="Movimientos.UsuarioQuienRecibe!=null">{{Movimientos.UsuarioQuienRecibe.Nombre}} {{Movimientos.UsuarioQuienRecibe.ApellidoPaterno!=null ? Movimientos.UsuarioQuienRecibe.ApellidoPaterno: ""}} {{Movimientos.UsuarioQuienRecibe.ApellidoMaterno!=null ? Movimientos.UsuarioQuienRecibe.ApellidoMaterno : ""}}</td>
                                      <td witdh="300" v-else></td>
                                      <td witdh="150" v-html="obtenFechaConFormato(Movimientos.FechaRecepcion)"></td>
                                      <!-- <td class="text-center" witdh ="50">
                                            <a v-on:click="EliminarDocumentoEnvio(Lista, Movimientos)" title="Eliminar Elemento de Lista">
                                                    <i class="fas fa-minus-circle"></i>
                                            </a>
                                      </td> -->
                                      <td width="30" class="category_enabled text-center">
                                            <input type="checkbox" v-model="SelEnviar" v-bind:value="Movimientos" @click="checkDocumento($event)"/>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                    </div>
                    <div id="BotonMover_div" class="text-right" v-if="ListaEnvios.length>0">
                        <button class="btn btn-sm btn-success" @click='Enviar()'>Enviar Documento(s)</button>
                    </div>
                    <div v-if="modalEnvio==true">
                      <ModalEnvio :adminEnvio= this.EnviosArchivista :ListadoParaEnvio= this.MovimientosModal :TotalVolumenes= 0 :usrArea= this.Usuario :JuicioDatos= this.Juicio @dialogo='EstatusModal($event)'></ModalEnvio>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 padding-div-low" style="margin-top:0px;margin-bottom:0px;" v-if="parametros_Tipo.tipoId==2">
                <div class="area custom-area" style="margin-top: 0px">
                    <div class="row">
                        <h6 class="label-black">Listado de Documentos para Recepción, Total de Documentos : {{ListaRecepcion.length}}</h6>
                    </div>
                    <div class="row table-responsive">
                            <table class="table table-striped table-light table-hover table-sm" id="tablaRecepcion">
                                <thead class="thead-custom">
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Consecutivo</th>
                                        <th>Tipo de Elemento</th>
                                        <th>Usuario Emisor</th>
                                        <th>Usuario Receptor</th>
                                        <th>Fecha de Envío</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody class="text-dark" v-for="Lista in ListaRecepcion" :key ="Lista.InventarioDocumentoId">
                                    <tr >
                                      <td width ="170" v-bind:rowspan="Lista.Movimientos.length + 1" v-if="Lista.ListadoArchivo==false"><h6 class="label-black"><span class="badge badge-primary">{{Lista.TipoDocumento.Nombre}}</span></h6></td>
                                      <td width ="170" v-bind:rowspan="Lista.Movimientos.length + 1" v-else><h6 class="label-black"><span class="badge badge-warning">{{Lista.TipoDocumento.Nombre}}</span></h6></td>
                                      <td class="text-center" width ="80" v-bind:rowspan="Lista.Movimientos.length + 1">{{Lista.Consecutivo}}/{{Lista.Anio}}{{(Lista.Sufijo!=null ? ('-'+ Lista.Sufijo) : '')}}</td>
                                    </tr>
                                    <tr v-for="Movimientos in Lista.Movimientos" :key ="Movimientos.MovimientoDocumentoId" >
                                      <td width ="250" v-html="desglosaContenido(Movimientos)"></td>
                                      <td width ="250" v-if="Movimientos.UsuarioQuienPresta!=null">{{Movimientos.UsuarioQuienPresta.Nombre}} {{Movimientos.UsuarioQuienPresta.ApellidoPaterno!=null ? Movimientos.UsuarioQuienPresta.ApellidoPaterno: ""}} {{Movimientos.UsuarioQuienPresta.ApellidoMaterno!=null ? Movimientos.UsuarioQuienPresta.ApellidoMaterno : ""}}</td>
                                      <td witdh="250" v-else-if="Movimientos.UsuarioQuienPresta==null && Movimientos.AreaExterna!=null">Área Externa: {{Movimientos.AreaExterna.Nombre}}</td>
                                      <td witdh="250" v-else></td>
                                      <td width ="250" v-if="Movimientos.UsuarioQuienRecibe!=null">{{Movimientos.UsuarioQuienRecibe.Nombre}} {{Movimientos.UsuarioQuienRecibe.ApellidoPaterno!=null ? Movimientos.UsuarioQuienRecibe.ApellidoPaterno: ""}} {{Movimientos.UsuarioQuienRecibe.ApellidoMaterno!=null ? Movimientos.UsuarioQuienRecibe.ApellidoMaterno : ""}}</td>
                                      <td witdh="250" v-else></td>
                                      <td class="text-center" witdh="150" v-html="obtenFechaConFormato(Movimientos.FechaMovimiento)"></td>
                                      <td class="text-center" witdh ="50">
                                            <a v-on:click="EliminarDocumentoRecepcion(Lista, Movimientos)" title="Eliminar Elemento de Lista">
                                                    <i class="fas fa-minus-circle"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                    </div>
                    <div id="BotonMover_div" class="text-right" v-if="ListaRecepcion.length>0">
                        <button class="btn btn-sm btn-dark" @click='Recibir()'>Recepción Documento(s)</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import ModalParaEnvio from '@/components/ArchivoJudicial/Comun/DatosEnvio.vue'

export default {
  components: {
        ModalEnvio: ModalParaEnvio
  },
  data(){
        return{
            Listado: [],
            CodigoBarras: "",
            ListaEnvios: [],
            ListaRecepcion: [],
            MovimientosModal:[],
            AreaQueConsulta: {},
            ubicacionActual:"",
            Tipos: [
                {TipoId: 1, Nombre: "ENVÍO"},
                {TipoId: 2, Nombre: "RECEPCIÓN"}
            ],
            parametros_Tipo: {
                tipoId: 0
            },
            modalEnvio: false,
            EnviosArchivista: true,
            Usuario : {},
            Juicio : {},
            SelEnviar : [],
            checkListadoArchivo: false
        }
  },
  methods: {
    cambiarTipo(datos){
            if(this.ListaEnvios.length>0 && parseInt(datos.target.value)==2 )
            {
                bootbox.confirm({
                        title: "Mensaje del sistema",
                        message: "Existen Documentos en la Lista para envio pendiente, Si decide cambiar el tipo de movimiento, perdera el listado ya capturado.<br />¿Desea continuar?",
                        buttons: {
                        cancel: {
                            label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                        },
                        confirm: {
                            label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar'
                        }
                },
                callback: (respuestaSalir) => {
                      if (respuestaSalir) {
                        this.parametros_Tipo.tipoId = parseInt(datos.target.value);
                        this.ListaEnvios = [];
                        this.SelEnviar = [];
                      }
                      else
                      {
                        $("#catalogoDeTipos").val(this.parametros_Tipo.tipoId);
                      }
                    }
                });
            }

            if(this.ListaRecepcion.length>0 && parseInt(datos.target.value)==1)
            {
                bootbox.confirm({
                        title: "Mensaje del sistema",
                        message: "Existen Documentos en la Lista para recepción pendiente, Si decide cambiar el tipo de movimiento, perdera el listado ya capturado.<br />¿Desea continuar?",
                        buttons: {
                        cancel: {
                            label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                        },
                        confirm: {
                            label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar'
                        }
                },
                callback: (respuestaSalir) => {
                      if (respuestaSalir) {
                        this.parametros_Tipo.tipoId = parseInt(datos.target.value);
                        this.ListaRecepcion = [];
                      }
                      else
                      {
                        $("#catalogoDeTipos").val(this.parametros_Tipo.tipoId);
                      }
                    }
                });
            }

            if(this.ListaEnvios.length==0 && this.ListaRecepcion.length==0)
            {
              this.parametros_Tipo.tipoId = parseInt(datos.target.value);
            }
            this.CodigoBarras = "";
    },
    obtenFechaConFormato: function(fechaRegistro) {
        return moment(fechaRegistro).format("DD-MM-YYYY");
    },
    ConsultarDocumento(){
      var tipo = this.parametros_Tipo.tipoId;
      var Resultado = this.ChecaCodigo(this.CodigoBarras);
      debugger
      if(Resultado.Estatus == true)
      {
        if(this.VerificaEnListado(this.CodigoBarras) == true)
        {
          comun.mensajeDeAlerta("El documento ya existe en el listado.", null, null);
        }
        else
        {
          var peticion = {
                  "AreaId": -1,
                  "TipoDocumentoId" : -1,
                  "Anio" : null,
                  "Consecutivo": null,
                  "CodigoBarras": this.CodigoBarras.trim(),
                  "Archivo": true
              };
          axios.post(api.conexion + api.ArchivoJudicial.ObtenerDocumento, peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
          .then( respuesta => {
            if(respuesta.data.SiHayError)
            {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            }
            else
            {   
              var DocumentoObtenido = respuesta.data.GetDocumento;
              var ListadoArchivo = respuesta.data.Listado;
              this.Usuario = respuesta.data.Usuario;
              this.Juicio= DocumentoObtenido.Juicio;
              console.log(respuesta)
              if(DocumentoObtenido!=null && DocumentoObtenido.InventarioDocumentoId>0)
              {
                if(this.checaUbicacionElementos(DocumentoObtenido, this.AreaQueConsulta.Area.AreaId)==true)
                {
                  switch(tipo)
                  {
                    case 1:
                      if(ListadoArchivo!=null)
                      {
                        this.checkListadoArchivo = true;
                        comun.mensajeDeAlerta('<label class="text-warning">Documento registrado Listado de Archivo' + (ListadoArchivo.Devolucion==false? ' Nuevo Ingreso.' : ' Devueltos.') + '<br>Fecha de Envio pendiente :&nbsp' + this.obtenFechaConFormato(ListadoArchivo.FechaEnvio)+ '</label>', null, null);
                      }
                      else
                      {
                        this.checkListadoArchivo = false;
                      }
                      this.ObtenerListaParaEnvio(DocumentoObtenido);
                      break;
                    case 2:
                      if(ListadoArchivo!=null)
                      {
                        this.checkListadoArchivo = true;
                        comun.mensajeDeAlerta('<label class="text-warning">Documento registrado en Listado de Archivo' + (ListadoArchivo.Devolucion==false? ' Nuevo Ingreso.' : ' Devueltos.') + '<br>Fecha de Envio pendiente :&nbsp' + this.obtenFechaConFormato(ListadoArchivo.FechaEnvio)+ '</label>', null, null);
                      }
                      else
                      {
                        this.checkListadoArchivo = false;
                      }
                      this.ObtenerListaRecepcion(DocumentoObtenido);
                      break;
                    default:
                      comun.mensajeDeAlerta("Seleccione un tipo de movimiento", null, null);
                      break
                  };
                }
                else
                {
                  comun.mensajeDeAlerta('<label class="text-warning">La ubicación de este Documento es distinta al área que consulta,<br>Ubicación actual :&nbsp' + this.ubicacionActual + '</label>', null, null);
                }
              }                 
            }
          })
          .catch(excepcion => {
                        console.log(excepcion);
                        console.log("fallo por parametros");
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                  });
        }
      }
      else
      {
        comun.mensajeDeAlerta(Resultado.Mensaje, null, null);
      };
    },
    ObtenerListaParaEnvio(documento){
      let _this = this;
      var peticion={"CodigoBarras": documento.CodigoBarras };
      comun.SeEstaCargandoInformacion(true);
      axios.post(api.conexion + api.ArchivoJudicial.GenerarListaTodos, peticion, comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
        .then( respuesta =>{
          if(respuesta.data.SiHayError)
            {
                    console.log(respuesta);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          }
          else
          {
            var DocumentosEnvio = respuesta.data;
            comun.SeEstaCargandoInformacion(false);
            if(DocumentosEnvio.GetListaDocumentos.length>0 || DocumentosEnvio.GetListaIncidentes.length>0 || DocumentosEnvio.GetListaTercerias.length>0)
            {
              this.formatoTablaEnvio(documento, DocumentosEnvio);
            }
            else
            {
                      var mensajeExtendido ="";
                      if(documento.Volumenes!=null && documento.Volumenes.length>0)
                      {
                        $.each(documento.Volumenes, function(a, volumen){
                          mensajeExtendido = mensajeExtendido + "Tomo No. " + volumen.NumVolumen + ",  "+ "Ubicación Actual: "   + _this.getUbicacionToTable(volumen, null, null) + "</br>"
                          mensajeExtendido = mensajeExtendido
                          if(volumen.MovimientoVolumen.UsuarioQuienRecibe!=null)
                          {
                            mensajeExtendido = mensajeExtendido + "Enviado para: " + volumen.MovimientoVolumen.UsuarioQuienRecibe.Nombre + " " +volumen.MovimientoVolumen.UsuarioQuienRecibe.ApellidoPaterno + " " + volumen.MovimientoVolumen.UsuarioQuienRecibe.ApellidoMaterno +  "</br>"
                          }
                          else{
                            mensajeExtendido = mensajeExtendido + "Enviado para: "+ (volumen.MovimientoVolumen.AreaQueRecibe!=null ? volumen.MovimientoVolumen.AreaQueRecibe.Nombre : "") + + "</br>"
                          }
                          
                          // if(volumen.MovimientoVolumen!=null)
                          // {
                          //   if(volumen.MovimientoVolumen.FechaRecepcion==null)
                          //   {
                          //     if(volumen.MovimientoVolumen.AreaExterna==null)
                          //     {
                          //       mensajeExtendido = mensajeExtendido + "Ubicación Actual: " + volumen.MovimientoVolumen.AreaQuePresta.Nombre + "</br>"
                          //     }
                          //     else
                          //     {
                          //       mensajeExtendido = mensajeExtendido + "Ubicación Actual: " + volumen.MovimientoVolumen.AreaExterna.Nombre + " " + ((volumen.MovimientoVolumen.DetallesExternos!= null && volumen.MovimientoVolumen.DetallesExternos.Numero>0 )?  volumen.MovimientoVolumen.DetallesExternos.Numero : "") + "</br>"
                          //     }
                          //     var nombreAreaREcibe = volumen.MovimientoVolumen.AreaQueRecibe != null ? volumen.MovimientoVolumen.AreaQueRecibe.Nombre : "";
                          //     mensajeExtendido = mensajeExtendido + "Tomo No. " + volumen.NumVolumen + " por: " + (volumen.MovimientoVolumen.UsuarioQuienRecibe!=null ? (volumen.MovimientoVolumen.UsuarioQuienRecibe.Nombre + " " +volumen.MovimientoVolumen.UsuarioQuienRecibe.ApellidoPaterno + " " + volumen.MovimientoVolumen.UsuarioQuienRecibe.ApellidoMaterno) : 
                          //                                                                                                                   nombreAreaREcibe) + "</br>";
                          //   }
                          // }
                        });
                      }
                      if(documento.Tercerias!=null && documento.Tercerias.length>0)
                      {
                        $.each(documento.Tercerias, function(a, terceria){
                          mensajeExtendido = mensajeExtendido + "Terceria No. " + terceria.NumeroTerceria + ", " + "Ubicación Actual: " + _this.getUbicacionToTable(null, null, terceria) + "</br>"

                          if(terceria.MovimientoTerceria.UsuarioQuienRecibe!=null)
                          {
                            mensajeExtendido = mensajeExtendido + "Enviado para: " + terceria.MovimientoTerceria.UsuarioQuienRecibe.Nombre + " " + terceria.MovimientoTerceria.UsuarioQuienRecibe.ApellidoPaterno + " " + terceria.MovimientoTerceria.UsuarioQuienRecibe.ApellidoMaterno + "</br>"
                          }
                          else{
                            mensajeExtendido = mensajeExtendido + "Enviado para: " +(terceria.MovimientoTerceria.AreaQueRecibe!=null ? terceria.MovimientoTerceria.AreaQueRecibe.Nombre : "") + + "</br>"
                          }
                          // if(terceria.MovimientoTerceria!=null)
                          // {
                          //   if(terceria.MovimientoTerceria.FechaRecepcion==null)
                          //   {
                          //    if(terceria.MovimientoTerceria.AreaExterna==null)
                          //     {
                          //       mensajeExtendido = mensajeExtendido + "Ubicación Actual: " + terceria.MovimientoTerceria.AreaQuePresta.Nombre + "</br>"
                          //     }
                          //     else
                          //     {
                          //       mensajeExtendido = mensajeExtendido + "Ubicación Actual: " + terceria.MovimientoTerceria.AreaExterna.Nombre + " " + (terceria.MovimientoTerceria.DetallesExternos.Numero>0 ?  terceria.MovimientoTerceria.DetallesExternos.Numero : "") + "</br>"
                          //     }
                          //     mensajeExtendido = mensajeExtendido + "Tercería No. " + terceria.NumeroTerceria + " por: " + (terceria.MovimientoTerceria.UsuarioQuienRecibe!=null ? (terceria.MovimientoTerceria.UsuarioQuienRecibe.Nombre + " " + terceria.MovimientoTerceria.UsuarioQuienRecibe.ApellidoPaterno + " " + terceria.MovimientoTerceria.UsuarioQuienRecibe.ApellidoMaterno) : 
                          //                                                                                       (terceria.MovimientoTerceria.AreaQueRecibe!=null ? terceria.MovimientoTerceria.AreaQueRecibe.Nombre : "" )) + "</br>";
                          //   }
                          // }
                        });
                      }
                      if(documento.Incidentes!=null && documento.Incidentes.length>0)
                      {
                        $.each(documento.Incidentes, function(a, incidente){
                          mensajeExtendido = mensajeExtendido + "Incidente No. " + incidente.NumeroIncidente + ",  " + "Ubicación Actual: " + _this.getUbicacionToTable(null, incidente, null) + "</br>"
                          if(incidente.MovimientoIncidente.UsuarioQuienRecibe!=null)
                          {
                            mensajeExtendido = mensajeExtendido + "Enviado para: " + incidente.MovimientoIncidente.UsuarioQuienRecibe.Nombre + " " + incidente.MovimientoIncidente.UsuarioQuienRecibe.ApellidoPaterno + " " + incidente.MovimientoIncidente.UsuarioQuienRecibe.ApellidoMaterno + "</br>"
                          }
                          else{
                            mensajeExtendido = mensajeExtendido + "Enviado para: " +(incidente.MovimientoIncidente.AreaQueRecibe!=null ? incidente.MovimientoIncidente.AreaQueRecibe.Nombre : "") + + "</br>"
                          }
                          // if(incidente.MovimientoIncidente!=null)
                          // {
                          //   if(incidente.MovimientoIncidente.FechaRecepcion==null)
                          //   {
                          //     if(incidente.MovimientoIncidente.AreaExterna==null)
                          //     {
                          //       mensajeExtendido = mensajeExtendido + "Ubicación Actual: " + incidente.MovimientoIncidente.AreaQuePresta.Nombre + "</br>"
                          //     }
                          //     else
                          //     {
                          //       mensajeExtendido = mensajeExtendido + "Ubicación Actual: " + incidente.Movimientoincidente.AreaExterna.Nombre + " " + (volumen.MovimientoIncidente.DetallesExternos.Numero>0 ?  volumen.MovimientoIncidente.DetallesExternos.Numero : "") + "</br>"
                          //     }
                          //     mensajeExtendido = mensajeExtendido + "Incidente No. " + incidente.NumeroIncidente + " por: " + (incidente.MovimientoIncidente.UsuarioQuienRecibe!=null ? (incidente.MovimientoIncidente.UsuarioQuienRecibe.Nombre + " " + incidente.MovimientoIncidente.UsuarioQuienRecibe.ApellidoPaterno + " " + incidente.MovimientoIncidente.UsuarioQuienRecibe.ApellidoMaterno) : 
                          //                                                                                               (incidente.MovimientoIncidente.AreaQueRecibe!=null ? incidente.MovimientoIncidente.AreaQueRecibe.Nombre : "") )+ "</br>";
                          //   }
                          // }
                        });
                      }
                      comun.mensajeDeAlerta('<label class="text-warning">Este documento esta en proceso de recepción en sistema: </br>' + mensajeExtendido +'</label>', null, null);
            }
            this.CodigoBarras= null;
          }
        })
        .catch( excepcion =>{
          console.log(excepcion);
          console.log("fallo por parametros");
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
          comun.SeEstaCargandoInformacion(false);
        });
    },
    DetectarEnter: function(e) {
      var Resultado = {};
      if (e.keyCode==13)
      {
        if(this.CodigoBarras != null || this.CodigoBarras != "")
            {
              Resultado = this.ChecaCodigo(this.CodigoBarras);
              if(Resultado.Estatus==true)
              {
                this.ConsultarDocumento();
              }
              else
              {
                comun.mensajeDeAlerta(Resultado.Mensaje, null, null);
              }
        }
        else
            {
              comun.mensajeDeAlerta("Escriba/Escan Código de Barras", null, null);
        }
      };
    },
    ChecaCodigo: function(codigo){
          var Verificado= {
              Estatus: false,
              Mensaje: ""
          }
          if(this.AreaQueConsulta.Area.AreaId!=95)
          {
            switch(codigo.length)
            {
              case 13:
                var estado = !isNaN(parseFloat(codigo)) && isFinite(codigo);
                if (estado==false)
                {
                  Verificado.Estatus = estado;
                  Verificado.Mensaje = "Verificar código de barras, debe ser numerico"
                }
                else
                {
                  Verificado.Estatus = estado;
                  Verificado.Mensaje = ""
                }
                break;
              default:
                  Verificado.Estatus = false;
                  if(codigo.length<13)
                  {
                    Verificado.Mensaje = "Verificar código de barras, debe completar los 13 digitos numericos"
                  };
                  if(codigo.length>13)
                  {
                    Verificado.Mensaje = "Verificar código de barras, sobrepasa los 13 digitos numericos"
                  }
                
                break;  
            }
          }
          else
          {
            switch(codigo.length)
            {
              case 13:
                var estado = !isNaN(parseFloat(codigo)) && isFinite(codigo);
                var anio = parseInt(codigo.substr(5,4));
                console.log(anio);
                if(anio<=2020)
                {
                  Verificado.Estatus = false;
                  Verificado.Mensaje = "Verificar código de barras, para documento del 2020 o inferiores se requiere complementar con numero romano correspondiente al área a consultar"
                                        + "</br>I   .- Juzgado Primero de Ejecución."
                                        + "</br>II  .- Juzgado Segundo de Ejecución."
                                        + "</br>III .- Unidad de Gestión";
                }
                else
                {
                  if (estado==false)
                  {
                    Verificado.Estatus = estado;
                    Verificado.Mensaje = "Verificar código de barras, debe ser numerico"
                  }
                  else
                  {
                    Verificado.Estatus = estado;
                    Verificado.Mensaje = ""
                  }
                }
                break;
              case 14:
                var anio = parseInt(codigo.substr(5,4));
                var numerico14 = codigo.substr(0,13);
                var romano14 = codigo.substr(13,1);
                if(anio<=2020)
                {
                  var estadoNumerico14 = !isNaN(parseFloat(numerico14)) && isFinite(numerico14);
                  var estadoRomano14 = romano14!="I" ? false: true;
                  if(estadoNumerico14==true && estadoRomano14 ==true)
                  {
                    Verificado.Estatus = estadoNumerico14;
                    Verificado.Mensaje = ""
                  }
                  else
                  {
                    if(estadoNumerico14==false && estadoRomano14 ==true)
                    {
                      Verificado.Estatus = false;
                      Verificado.Mensaje = "Verificar código, los primeros 13 digitos deben ser numero"
                    }
                    if(estadoNumerico14==true && estadoRomano14 ==false)
                    {
                      Verificado.Estatus = false;
                      Verificado.Mensaje = "Verificar código, numero romano no corresponde"
                    }
                  }
                }
                else
                {
                  Verificado.Estatus = false;
                  Verificado.Mensaje = "Para documentos del 2021 o superiores no requiere numero romano"
                }
                break;
              case 15:
                var anio = parseInt(codigo.substr(5,4));
                var numerico15 = codigo.substr(0,13);
                var romano15 = codigo.substr(13,2);
                if(anio<=2020)
                {
                  var estadoNumerico15 = !isNaN(parseFloat(numerico15)) && isFinite(numerico15);
                  var estadoRomano15 = romano15!="II" ? false: true;
                  if(estadoNumerico15==true && estadoRomano15 ==true)
                  {
                    Verificado.Estatus = estadoNumerico15;
                    Verificado.Mensaje = ""
                  }
                  else
                  {
                    if(estadoNumerico15==false && estadoRomano15 ==true)
                    {
                      Verificado.Estatus = false;
                      Verificado.Mensaje = "Verificar código, los primeros 13 digitos deben ser numero"
                    }
                    if(estadoNumerico15==true && estadoRomano15 ==false)
                    {
                      Verificado.Estatus = false;
                      Verificado.Mensaje = "Verificar código, numero romano no corresponde"
                    }
                  }
                }
                else
                {
                  Verificado.Estatus = false;
                  Verificado.Mensaje = "Para documentos del 2021 o superiores no requiere numero romano"
                }
                break;
              case 16:
                var anio = parseInt(codigo.substr(5,4));
                var numerico16 = codigo.substr(0,13);
                var romano16 = codigo.substr(13,3);
                if(anio<=2020)
                {
                  var estadoNumerico16 = !isNaN(parseFloat(numerico16)) && isFinite(numerico16);
                  var estadoRomano16 = romano16!="III" ? false: true;
                  if(estadoNumerico16==true && estadoRomano16 ==true)
                  {
                    Verificado.Estatus = estadoNumerico16;
                    Verificado.Mensaje = ""
                  }
                  else
                  {
                    if(estadoNumerico16==false && estadoRomano16 ==true)
                    {
                      Verificado.Estatus = false;
                      Verificado.Mensaje = "Verificar código, los primeros 13 digitos deben ser numericos"
                    }
                    if(estadoNumerico16==true && estadoRomano16 ==false)
                    {
                      Verificado.Estatus = false;
                      Verificado.Mensaje = "Verificar código, numero romano no corresponde"
                    }
                  }
                }
                else
                {
                  Verificado.Estatus = false;
                  Verificado.Mensaje = "Para documentos del 2021 o superiores no requiere numero romano"
                }
                break;
              default:
                  Verificado.Estatus = false;
                  if(codigo.length<13)
                  {
                    Verificado.Mensaje = "Verificar código de barras, debe completar los 13 digitos numericos y en su caso numero romano"
                  };
                  if(codigo.length>16)
                  {
                    Verificado.Mensaje = "Verificar código de barras, sobrepasa los 16 digitos"
                  }
                
                break;  
            }
          }
          return Verificado;
    },
    checaUbicacionElementos(documentos, areaActual){
          var contador = 0;
          var Uactual = "";
          
          $.each(documentos.Volumenes, function(index, listado)
          {
            Uactual =listado.Area.Nombre;
            if(listado.Area.AreaId == areaActual)
            {
              contador += 1;
            }
            else
            {
              if(listado.MovimientoVolumen!=null)
                {
                if(listado.MovimientoVolumen.AreaQueRecibe.AreaId == areaActual)
                  {
                    contador += 1;
                    
                  }
                }
            }
          });

          $.each(documentos.Incidentes, function(index, listado)
          {
            Uactual =listado.Area.Nombre;
            if(listado.Area.AreaId == areaActual)
            {
              contador += 1;
            }
            else
            {
              if(listado.MovimientoIncidente!=null)
                {
                if(listado.MovimientoIncidente.AreaQueRecibe.AreaId == areaActual)
                  {
                    contador += 1;
                    
                  }
                }
            }
          });
          $.each(documentos.Tercerias, function(index, listado)
          {
            Uactual =listado.Area.Nombre;
            if(listado.Area.AreaId == areaActual)
            {
              contador += 1;
            }
            else
            {
              if(listado.MovimientoIncidente!=null)
                {
                if(listado.MovimientoIncidente.AreaQueRecibe.AreaId == areaActual)
                  {
                    contador += 1;
                    
                  }
                }
            }
          });

          this.ubicacionActual = Uactual;
          
          if(contador > 0)
          {
            return true;
          }
          else
          {
            return false;
          }
    },
    formatoTablaEnvio(documento, datos){
            let _this = this;
            var listaPrevia = []
            if(datos.GetListaDocumentos.length>0)
            {
                $.each(datos.GetListaDocumentos, function(index, listado)
                {
                    listaPrevia.push(listado);
                })
            };
          var elemento =this.AgruparInventarioDocumentoId(documento, listaPrevia)
          this.checkListadoArchivo = false;
          this.ListaEnvios.push(elemento);
          this.ListaEnvios.sort((a,b)=>(a.CodigoBarras>b.CodigoBarras ? 1:-1));
          $.each(elemento.Movimientos, function(id, movimiento){
            if(movimiento.VolumenId!=null ){//|| movimiento.IncidenteId!=null || movimiento.TerceriaId!=null){ // agregado || movimiento.IncidenteId!=null || movimiento.TerceriaId!=null
              _this.SelEnviar.push(movimiento)
            }
          })
    },
    formatoTablaRecepcion(documento, datos){
          let _this = this;
            var listaPrevia = []
            if(datos.GetListaParaRecepcion.length>0)
            {
                $.each(datos.GetListaParaRecepcion, function(index, listado)
                {
                    listaPrevia.push(listado);
                })
            };
            if(datos.GetListaTercerias.length>0)
            {
                $.each(datos.GetListaTercerias, function(index, listado)
                {
                    listaPrevia.push(listado)
                })
            };
            if(datos.GetListaIncidentes.length>0)
            {
                $.each(datos.GetListaIncidentes, function(index, listado)
                {
                    listaPrevia.push(listado)
                })
            };
          
          this.ListaRecepcion.push(this.AgruparInventarioDocumentoId(documento, listaPrevia));
          this.ListaRecepcion.sort((a,b)=>(a.CodigoBarras>b.CodigoBarras ? 1:-1));
    },
    EliminarDocumentoEnvio(lista, datos){
          var IndiceDocumento = this.ListaEnvios.indexOf(lista);
          var IndiceElemento = this.ListaEnvios[IndiceDocumento].Movimientos.indexOf(datos);
           bootbox.confirm({
            title: "Mensaje del sistema",
            message: "Desea Eliminar el Elemento de la Lista para Envío?",
            buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
              },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
              }
            },
            callback: (respuestaSalir) => {
              if (respuestaSalir) {
                this.ListaEnvios[IndiceDocumento].Movimientos.splice(IndiceElemento,1);
                if(this.ListaEnvios[IndiceDocumento].Movimientos.length==0)
                {
                  this.ListaEnvios.splice(IndiceDocumento,1);
                }
              }
              }
            });
    },
    EliminarDocumentoRecepcion(lista, datos){
          var IndiceDocumento = this.ListaRecepcion.indexOf(lista);
          var IndiceElemento = this.ListaRecepcion[IndiceDocumento].Movimientos.indexOf(datos);
           bootbox.confirm({
            title: "Mensaje del sistema",
            message: "Desea Eliminar el Elemento de la Lista para Envío?",
            buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
              },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
              }
            },
            callback: (respuestaSalir) => {
              if (respuestaSalir) {
                this.ListaRecepcion[IndiceDocumento].Movimientos.splice(IndiceElemento,1);
                if(this.ListaRecepcion[IndiceDocumento].Movimientos.length==0)
                {
                  this.ListaRecepcion.splice(IndiceDocumento,1);
                }
              }
              }
            });
    },
    AgruparInventarioDocumentoId(documento, datos){
            var ListaInicial=[];
            var EnListado  = this.checkListadoArchivo;
            $.each(datos, function(index, datosEnvio)
            {
              // var volumenesTemporal = {
              //   "Area" : documento.Volumenes[0].Area,
              //   "Amparos" : documento.Volumenes[0].Amparos,
              //   "InventarioDocumentoId" : documento.Volumenes[0].InventarioDocumentoId,
              //   "VolumenId" : documento.Volumenes[0].VolumenId,
              //   "NumVolumen" : documento.Volumenes[0].NumVolumen,
              //   "Contenedor" : documento.Volumenes[0].Contenedor,
              //   "EstatusVolumenes" : documento.Volumenes[0].EstatusVolumenes,
              // }; //documento.Volumenes[index];
              var chequeo = ListaInicial.find(e=>e.InventarioDocumentoId == documento.InventarioDocumentoId);
              if(chequeo == undefined || chequeo == false)
              {
                  ListaInicial.push({"InventarioDocumentoId": documento.InventarioDocumentoId,
                                      "TipoDocumento": documento.TipoDocumento,
                                      "Anio": documento.Anio,
                                      "CodigoBarras": documento.CodigoBarras,
                                      "Consecutivo": documento.Consecutivo,
                                      "Sufijo" : documento.Sufijo,
                                      "Partes": documento.Partes,
                                      "Juicio": documento.Juicio,
                                      "SedeArchivo": documento.SedeArchivo,
                                      "FechaRegistroArchivo":documento.FechaRegistroArchivo,
                                      "Volumenes": documento.Volumenes,
                                      "ListadoArchivo" : EnListado,
                                      "Movimientos": [
                                          {
                                          "MovimientoDocumentoId": datosEnvio.MovimientoDocumentoId,
                                          "SolicitudDocumentoId": datosEnvio.SolicitudDocumentoId !=null ? datosEnvio.SolicitudDocumentoId : null,
                                          "FechaMovimiento": datosEnvio.FechaMovimiento,
                                          "UsuarioQuienPresta": datosEnvio.UsuarioQuienPresta,
                                          "UsuarioQuienRecibe": datosEnvio.UsuarioQuienRecibe,
                                          "AreaQuePresta": datosEnvio.AreaQuePresta,
                                          "AreaQueRecibe": datosEnvio.AreaQueRecibe,
                                          "AreaExterna": datosEnvio.AreaExterna,
                                          "IncidenteId": datosEnvio.IncidenteId,
                                          "Incidente": datosEnvio.Incidente!= null? datosEnvio.Incidente : null,
                                          "VolumenId": datosEnvio.VolumenId,
                                          "Volumen": datosEnvio.Volumen!=null ? datosEnvio.Volumen : null,
                                          "TerceriaId": datosEnvio.TerceriaId,
                                          "Terceria": datosEnvio.Terceria!=null ? datosEnvio.Terceria : null,
                                          "TiposMovimientos": datosEnvio.TiposMovimientos,
                                          "FechaRecepcion": datosEnvio.FechaRecepcion
                                          }],
                                      });
                                  
              }
              else{
                  chequeo.Movimientos.push({
                                      "MovimientoDocumentoId": datosEnvio.MovimientoDocumentoId,
                                      "SolicitudDocumentoId": datosEnvio.SolicitudDocumentoId !=null ? datosEnvio.SolicitudDocumentoId : null,
                                      "FechaMovimiento": datosEnvio.FechaMovimiento,
                                      "UsuarioQuienPresta": datosEnvio.UsuarioQuienPresta,
                                      "UsuarioQuienRecibe": datosEnvio.UsuarioQuienRecibe,
                                      "AreaQuePresta": datosEnvio.AreaQuePresta,
                                      "AreaQueRecibe": datosEnvio.AreaQueRecibe,
                                      "AreaExterna": datosEnvio.AreaExterna,
                                      "IncidenteId": datosEnvio.IncidenteId,
                                      "Incidente": datosEnvio.Incidente!= null? datosEnvio.Incidente : null,
                                      "VolumenId": datosEnvio.VolumenId,
                                      "Volumen": datosEnvio.Volumen!=null ? datosEnvio.Volumen : null,
                                      "TerceriaId": datosEnvio.TerceriaId,
                                      "Terceria": datosEnvio.Terceria!=null ? datosEnvio.Terceria : null,
                                      "TiposMovimientos": datosEnvio.TiposMovimientos,
                                      "FechaRecepcion": datosEnvio.FechaRecepcion});
              }
          });
          
          return ListaInicial[0];
    },
    Enviar() {
          var aEnviar = this.ObtenerSeleccionadosEnvio();
          this.SelEnviar = [];
          this.MovimientosModal = aEnviar;
          if (this.MovimientosModal.length>0)
              {
                this.modalEnvio = true;
              }
              else
              {
                this.modalEnvio = false;
                comun.mensajeDeAlerta("No hay elementos para envío.", null, null);
              }
    },
    EstatusModal(valor){
            this.modalEnvio = valor.Cerrado;
            if(valor.Enviado==true)
            {
              this.MovimientosModal = [];
              this.ListaEnvios = [];
              this.ListaRecepcion = [];
              comun.mensajeDeAlerta("Se han enviado los documentos en listado.", null, null);
            }
            
    },
    ObtenerListaRecepcion(documento){
            var peticion={
                  "CodigoBarras": documento.CodigoBarras
            }
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.TodosRecepcion, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
                if(respuesta.data.SiHayError)
                {
                    console.log(respuesta);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                }
                else
                {
                    var DocumentosRecepcion = respuesta.data;

                    comun.SeEstaCargandoInformacion(false);
                    if(DocumentosRecepcion.GetListaParaRecepcion.length>0 || DocumentosRecepcion.GetListaIncidentes.length>0 || DocumentosRecepcion.GetListaTercerias.length>0)
                    {
                      this.formatoTablaRecepcion(documento, DocumentosRecepcion);
                    }
                    else
                    {
                      var mensajeExtendido ="";
                      var mensajeExtendido2 =""
                      if(documento.Volumenes.length>0)
                      {
                        $.each(documento.Volumenes, function(a, volumen){
                          if(volumen.MovimientoVolumen!=null)
                          {
                            if(volumen.MovimientoVolumen.FechaRecepcion!=null)
                            {
                              mensajeExtendido = mensajeExtendido + "Tomo No. " + volumen.NumVolumen + " recibido por " + volumen.MovimientoVolumen.UsuarioQuienRecibe.Nombre + " " +volumen.MovimientoVolumen.UsuarioQuienRecibe.ApellidoPaterno + " " + volumen.MovimientoVolumen.UsuarioQuienRecibe.ApellidoMaterno + "</br>";
                            }
                            else
                            {
                              mensajeExtendido2 = mensajeExtendido2 + "Tomo No. " + volumen.NumVolumen + " por " + (volumen.MovimientoVolumen.UsuarioQuienRecibe!=null ? (volumen.MovimientoVolumen.UsuarioQuienRecibe.Nombre + " " +volumen.MovimientoVolumen.UsuarioQuienRecibe.ApellidoPaterno + " " + volumen.MovimientoVolumen.UsuarioQuienRecibe.ApellidoMaterno) :  
                                                  (volumen.MovimientoVolumen.AreaQueRecibe!=null ? volumen.MovimientoVolumen.AreaQueRecibe.Nombre : "")) + "</br>";
                            }
                          }
                        });
                      }
                      if(documento.Tercerias.length>0)
                      {
                        $.each(documento.Tercerias, function(a, terceria){
                          if(terceria.MovimientoTerceria!=null)
                          {
                            if(terceria.MovimientoTerceria.FechaRecepcion!=null)
                            {
                              mensajeExtendido = mensajeExtendido + "Tercería No. " + terceria.NumeroTerceria + " por " + terceria.MovimientoTerceria.UsuarioQuienRecibe.Nombre + " " + terceria.MovimientoTerceria.UsuarioQuienRecibe.ApellidoPaterno + " " + terceria.MovimientoTerceria.UsuarioQuienRecibe.ApellidoMaterno + "</br>";
                            }
                            else
                            {
                              mensajeExtendido2 = mensajeExtendido2 + "Tercería No. " + terceria.NumeroTerceria + " por " + (terceria.MovimientoTerceria.UsuarioQuienRecibe!=null ? (terceria.MovimientoTerceria.UsuarioQuienRecibe.Nombre + " " + terceria.MovimientoTerceria.UsuarioQuienRecibe.ApellidoPaterno + " " + terceria.MovimientoTerceria.UsuarioQuienRecibe.ApellidoMaterno) :
                              (terceria.MovimientoTerceria.AreaQueRecibe!=null ? terceria.MovimientoTerceria.AreaQueRecibe : "")) + "</br>";
                            }
                          }
                        });
                      }
                      if(documento.Incidentes.length>0)
                      {
                        $.each(documento.Incidentes, function(a, incidente){
                          if(incidente.MovimientoIncidente!=null)
                          {
                            if(incidente.MovimientoIncidente.FechaRecepcion!=null)
                            {
                              mensajeExtendido = mensajeExtendido + "Incidente No. " + incidente.NumeroIncidente + " recibido por " + incidente.MovimientoIncidente.UsuarioQuienRecibe.Nombre + " " + incidente.MovimientoIncidente.UsuarioQuienRecibe.ApellidoPaterno + " " + incidente.MovimientoIncidente.UsuarioQuienRecibe.ApellidoMaterno + "</br>";
                            }
                            else
                            {
                              mensajeExtendido2 = mensajeExtendido2 + "Incidente No. " + incidente.NumeroIncidente + " recibido por " + (incidente.MovimientoIncidente.UsuarioQuienRecibe!=null ? (incidente.MovimientoIncidente.UsuarioQuienRecibe.Nombre + " " + incidente.MovimientoIncidente.UsuarioQuienRecibe.ApellidoPaterno + " " + incidente.MovimientoIncidente.UsuarioQuienRecibe.ApellidoMaterno): 
                              (incidente.MovimientoIncidente.AreaQueRecibe!=null ? incidente.MovimientoIncidente.AreaQueRecibe.Nombre : "")) + "</br>";
                            }
                          }
                        });
                      }
                      if(mensajeExtendido!="")
                      {
                        comun.mensajeDeAlerta('<label class="text-warning">El Documento consultado ya fue recibido en sistema : </br>' +  mensajeExtendido + '</label>', null, null);
                      };
                      if(mensajeExtendido2!="")
                      {
                        comun.mensajeDeAlerta('<label class="text-warning">El Documento tiene pendiente recepción en sistema : </br>' +  mensajeExtendido2 + '</label>', null, null);
                      }
                      
                    }
                    
                    this.CodigoBarras= null;
                }
                })
            .catch(excepcion => {
                    console.log(excepcion);
                    console.log("fallo por parametros");
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);

            })
    },
    Recibir() {
          var User = this.Usuario;
            var Movimientos= [];
              $.each(this.ListaRecepcion, function (index, documento){
                  $.each(documento.Movimientos, function(i, movIds)
                  {
                    
                    Movimientos.push({
                                  "MovimientoDocumentoId" : movIds.MovimientoDocumentoId,
                                  "VolumenId" : movIds.VolumenId,
                                  "IncidenteId": movIds.IncidenteId,
                                  "TerceriaId": movIds.TerceriaId,
                                  "FechaMovimiento" : movIds.FechaMovimiento,
                                  "TiposMovimientos" : {"TipoMovimientoId": movIds.TiposMovimientos.TipoMovimientoId},
                                  "UsuarioQuienPresta" : movIds.UsuarioQuienPresta !=null ? movIds.UsuarioQuienPresta : null,
                                  "AreaQuePresta" : movIds.AreaQuePresta != null ? movIds.AreaQuePresta: null,
                                  "UsuarioQuienRecibe" : movIds.UsuarioQuienRecibe!= null? movIds.UsuarioQuienRecibe : null ,
                                  "AreaQueRecibe" : movIds.AreaQueRecibe !=null? movIds.AreaQueRecibe :null,
                                  "SolicitudDocumentoId" : movIds.SolicitudDocumentoId,
                                  "FechaRegistro" : movIds.FechaRegistro,
                                  "UsuarioQuienRegistra" : {"IdUsuario": User.IdUsuario},
                                  "Observaciones" : movIds.Observaciones,
                                  "FechaRecepcion" : movIds.FechaRecepcion})
                  });
                  $.each(documento.Volumenes, function(id, vol)
                  {
                    
                    if(vol.Amparos!=null && vol.Amparos.length>0)
                    {
                      $.each(vol.Amparos, function (x, amparo)
                      {
                        Movimientos.push({
                                  "MovimientoDocumentoId" : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.MovimientoDocumentoId,
                                  "VolumenId" :amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.VolumenId,
                                  "IncidenteId": null,
                                  "TerceriaId": null,
                                  "FechaMovimiento" : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.FechaMovimiento,
                                  "TiposMovimientos" : {"TipoMovimientoId": amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.TiposMovimientos.TipoMovimientoId},
                                  "UsuarioQuienPresta" :amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.UsuarioQuienPresta !=null ? amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.UsuarioQuienPresta : null,
                                  "AreaQuePresta" : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.AreaQuePresta != null ? amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.AreaQuePresta: null,
                                  "UsuarioQuienRecibe" : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.UsuarioQuienRecibe!= null? amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.UsuarioQuienRecibe : null ,
                                  "AreaQueRecibe" : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.AreaQueRecibe !=null? amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.AreaQueRecibe :null,
                                  "SolicitudDocumentoId" : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.SolicitudDocumentoId,
                                  "FechaRegistro" : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.FechaRegistro,
                                  "UsuarioQuienRegistra" : {"IdUsuario": User.IdUsuario},
                                  "Observaciones" : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.Observaciones,
                                  "FechaRecepcion" : amparo.AmparosDelDocumento.Volumenes[0].MovimientoVolumen.FechaRecepcion
                                  })
                      })
                    }
                  })
                });
                var peticion={
                    Movimientos
                };
                
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.ArchivoJudicial.RecepcionDocumento, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then( respuesta => {
                  if(respuesta.data.SiHayError)
                    {
                      console.log(respuesta);
                      comun.SeEstaCargandoInformacion(false);
                      comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    }
                    else
                    {   
                      comun.SeEstaCargandoInformacion(false);
                      bootbox.confirm({
                      title: "Mensaje del sistema",
                      message: "Documentos recibidos.<br/><br/>Desea usar esta Lista para envío?",
                      buttons: {
                      cancel: {
                        className: 'btn btn-primary',
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;SOLO RECEPCIÓN'
                        },
                      confirm: {
                        className: 'btn btn-success',
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;ENVIAR A USUARIO'
                        }
                      },
                      callback: (respuestaSalir) => {
                          if (respuestaSalir) {
                          this.ListaEnvios= this.AcutalizaFechaParaReenvio(this.ListaRecepcion);
                          this.ListaRecepcion = [];
                          $("#catalogoDeTipos").val(1);
                          this.parametros_Tipo.tipoId=1;
                          }
                          else
                          {
                            this.ListaEnvios = [];
                            this.ListaRecepcion = [];
                          }
                        }
                      });

                      //comun.mensajeDeAlerta("Se ha recibido documentos en el listado", null, null);
                      
                    }
                    
                    })
                    .catch(excepcion => {
                      console.log(excepcion);
                      console.log("fallo por parametros");
                      comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                      comun.SeEstaCargandoInformacion(false);
                    })
    },
    VerificaEnListado(codigo){
            if(this.ListaEnvios.length>0 && this.parametros_Tipo.tipoId == 1)
            {
                var check = this.ListaEnvios.filter(e=>e.CodigoBarras == codigo).length;
                if(check>0){
                    this.CodigoBarras="";
                    return true;
                }
            };
            if(this.ListaRecepcion.length>0 && this.parametros_Tipo.tipoId==2)
            {
                var check = this.ListaRecepcion.filter(e=>e.CodigoBarras == codigo).length;
                if(check>0){
                    this.CodigoBarras="";
                    return true;
                }
            };
            return false;
    },
    desglosaContenido(datos){
          let Contenido='';
          if(datos.VolumenId!=null)
          {
              Contenido=Contenido + 'Tomo No: ' + datos.Volumen.NumVolumen + '<br>';
              // if(datos.Volumen.Amparos!=null && datos.Volumen.Amparos.length>0)
              // {
              //   $.each(datos.Volumen.Amparos, function (id, valor) {
              //     Contenido=Contenido + 'Amparo : ' + valor.AmparosDelDocumento.Consecutivo + "/" + valor.AmparosDelDocumento.Anio + '<br>';
              //   })
              // }
          }
          if(datos.IncidenteId!=null)
          {
            Contenido=Contenido + 'Incidente No: ' + datos.Incidente.NumeroIncidente + '<br>';
          };
          if(datos.TerceriaId!=null)
          {
            Contenido=Contenido + 'Terceria No: ' + datos.Terceria.NumeroTerceria + '<br>';
          }
          return Contenido;
    },
    AcutalizaFechaParaReenvio: function(data)
    {
      var arrayEnviar =[];
      $.each(data, function(id, documento)
      {
            $.each(documento.Movimientos, function(x, movimiento){
              movimiento.FechaRecepcion = moment();
              arrayEnviar.push(movimiento) //agregado
            }); 
      })
      this.SelEnviar = arrayEnviar; //agregado
      return data;
    },
    ObtenerSeleccionadosEnvio(){
            let documentosSeleccionados = [];
            let Listado = this.ListaEnvios;
            $.each(this.SelEnviar, function(id, movimiento)
            {
              var inventario = movimiento.VolumenId!=null ? (movimiento.Volumen.InventarioDocumentoId) : (movimiento.Terceria!=null ? movimiento.Terceria.InventarioDocumentoId : movimiento.Incidente.InventarioDocumentoId)
              var elemento =Listado.find(e=>e.InventarioDocumentoId == inventario);
              var chequeo = documentosSeleccionados.find(e=>e.InventarioDocumentoId == inventario);
              if(chequeo == undefined || chequeo == false)
              {
                documentosSeleccionados.push({"InventarioDocumentoId": elemento.InventarioDocumentoId,
                                    "TipoDocumento": elemento.TipoDocumento,
                                    "Anio": elemento.Anio,
                                    "CodigoBarras": elemento.CodigoBarras,
                                    "Consecutivo": elemento.Consecutivo,
                                    "Partes": elemento.Partes,
                                    "Juicio": elemento.Juicio,
                                    "SedeArchivo": elemento.SedeArchivo,
                                    "FechaRegistroArchivo":elemento.FechaRegistroArchivo,
                                    "Volumenes": elemento.Volumenes,
                                    "Movimientos": [
                                        {
                                        "MovimientoDocumentoId": movimiento.MovimientoDocumentoId,
                                        "SolicitudDocumentoId": movimiento.SolicitudDocumentoId,
                                        "FechaMovimiento": movimiento.FechaMovimiento,
                                        "UsuarioQuienPresta": movimiento.UsuarioQuienPresta,
                                        "UsuarioQuienRecibe": movimiento.UsuarioQuienRecibe,
                                        "AreaQuePresta": movimiento.AreaQuePresta,
                                        "AreaQueRecibe": movimiento.AreaQueRecibe,
                                        "AreaExterna": movimiento.AreaExterna,
                                        "IncidenteId": movimiento.IncidenteId,
                                        "Incidente": movimiento.Incidente,
                                        "VolumenId": movimiento.VolumenId,
                                        "Volumen": movimiento.Volumen,
                                        "TerceriaId": movimiento.TerceriaId,
                                        "Terceria": movimiento.Terceria,
                                        "TiposMovimientos": movimiento.TiposMovimientos,
                                        "FechaRecepcion": movimiento.FechaRecepcion
                                        }],
                                    });
              }
              else
              {
                chequeo.Movimientos.push({
                                    "MovimientoDocumentoId": movimiento.MovimientoDocumentoId,
                                    "SolicitudDocumentoId": movimiento.SolicitudDocumentoId,
                                    "FechaMovimiento": movimiento.FechaMovimiento,
                                    "UsuarioQuienPresta": movimiento.UsuarioQuienPresta,
                                    "UsuarioQuienRecibe": movimiento.UsuarioQuienRecibe,
                                    "AreaQuePresta": movimiento.AreaQuePresta,
                                    "AreaQueRecibe": movimiento.AreaQueRecibe,
                                    "AreaExterna": movimiento.AreaExterna,
                                    "IncidenteId": movimiento.IncidenteId,
                                    "Incidente": movimiento.Incidente,//!= null? datosEnvio.Incidente : null,
                                    "VolumenId": movimiento.VolumenId,
                                    "Volumen": movimiento.Volumen,//!=null ? datosEnvio.Volumen : null,
                                    "TerceriaId": movimiento.TerceriaId,
                                    "Terceria": movimiento.Terceria,//!=null ? datosEnvio.Terceria : null,
                                    "TiposMovimientos": movimiento.TiposMovimientos,
                                    "FechaRecepcion": movimiento.FechaRecepcion});
              }
              
            });
            
            return documentosSeleccionados;
    },
    checkDocumento(event){
    },
    getUbicacionToTable :function(volumen, incidente, terceria)
      {
        let nombreUbicacion=''
        if(volumen!=null)
        {
          if(volumen.MovimientoVolumen!=null)
          {
            if(volumen.MovimientoVolumen.FechaRecepcion!=null)
            {
              nombreUbicacion = volumen.Area.Nombre
            }
            else
            {
              if(volumen.MovimientoVolumen.AreaQuePresta!=null)
              {
                nombreUbicacion = volumen.MovimientoVolumen.AreaQuePresta.Nombre;
              }
              else{
                if(volumen.MovimientoVolumen.AreaExterna!=null)
                {
                  nombreUbicacion =volumen.MovimientoVolumen.AreaExterna.Nombre
                }
                else
                {
                  nombreUbicacion= volumen.Area.Nombre;
                }
              }
            }
          }
          else {
            nombreUbicacion= volumen.Area.Nombre;
          }
        }
        if(incidente!=null)
        {
          console.log(incidente)
          if(incidente.MovimientoIncidente!=null)
          {
            if(incidente.MovimientoIncidente.FechaRecepcion!=null)
            {
              nombreUbicacion = incidente.Area.Nombre
            }
            else
            {
              if(incidente.MovimientoIncidente.AreaQuePresta!=null)
              {
                nombreUbicacion = incidente.MovimientoIncidente.AreaQuePresta.Nombre;
              }
              else{
                if(incidente.MovimientoIncidente.AreaExterna!=null)
                {
                  nombreUbicacion =incidente.MovimientoIncidente.AreaExterna.Nombre
                }
                else
                {
                  nombreUbicacion= incidente.Area.Nombre;
                }
              }
            }
          }
          else {
            nombreUbicacion= incidente.Area.Nombre;
          }
        }

        if(terceria!=null)
        {
          if(terceria.MovimientoTerceria!=null)
          {
            if(terceria.MovimientoTerceria.FechaRecepcion!=null)
            {
              nombreUbicacion = terceria.Area.Nombre
            }
            else
            {
              if(terceria.MovimientoTerceria.AreaQuePresta!=null)
              {
                nombreUbicacion = terceria.MovimientoTerceria.AreaQuePresta.Nombre;
              }
              else{
                if(terceria.MovimientoTerceria.AreaExterna!=null)
                {
                  nombreUbicacion =terceria.MovimientoTerceria.AreaExterna.Nombre
                }
                else
                {
                  nombreUbicacion= terceria.Area.Nombre;
                }
              }
            }
          }
          else {
            nombreUbicacion= terceria.Area.Nombre;
          }
        }
        return nombreUbicacion;
      }
  },
  mounted(){
        this.AreaQueConsulta = this.$store.state.Login_Usuario;
        if(this.AreaQueConsulta.Area.AreaId==95)
        {
            comun.mensajeDeAlerta("Para la Consulta de Expedientes del Juzgado de Ejecución de Penas y Medidas de Seguridad anteriores al año 2021, debera completarse el Sufijo en Numero Romano de acuerdo a su procedencia:" 
                    + "</br>I   .- Juzgado Primero de Ejecución."
                    + "</br>II  .- Juzgado Segundo de Ejecución."
                    + "</br>III .- Unidad de Gestión"
                    + "</br>Por Codigo de Barras 42xxxXXXXxxxx + Sufijo."
                    , null, null);
        }
  },
  beforeRouteLeave (to, from, next) {
        if(this.ListaEnvios.length>0 || this.ListaRecepcion.length>0)
        {

            bootbox.confirm({
                    title: "Mensaje del sistema",
                    message: "Existen Documentos en la Lista para movimiento pendiente, Si decide salir , perdera el listado.<br />¿Desea continuar?",
                    buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar y salir'
                    }
            },
            callback: (respuestaSalir) => {
                  if (respuestaSalir) {
                    next();
                  }
                  else{
                      next(false);
                  }
                }
            });
        }
        else
        {
            next()
        }
  }
}
</script>

<style scoped>
    .thead-custom {
    background-color: #004746;
    color: white;
    }
    .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Movimientos/MovimientosJuzgado.vue